import React from 'react';
import styled, { keyframes } from 'styled-components';

import { loadingIcon } from '../media/icons';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const StyledFullScreenLoader = styled.div`
  align-items: center;
  background-color: ${p => p.theme.colors.bg};
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9999;
`;

const StyledLoader = styled.div`
  height: calc(100vh - 178px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.img`
  animation: ${rotate360} 1s linear infinite;
  display: block;
  margin: 0 auto 5px auto;
  width: 50px;
`;

const Text = styled.div`
  color: ${p => p.theme.colors.lightFont};
  display: block;
  font-size: 0.875rem;
  font-weight: 300;
  letter-spacing: 0.3px;
`;

export function FullScreenLoader() {
  return (
    <StyledFullScreenLoader>
      <Icon src={loadingIcon} />
      <Text>Laster…</Text>
    </StyledFullScreenLoader>
  );
}

export function Loader() {
  return (
    <StyledLoader>
      <Icon src={loadingIcon} />
      <Text>Laster…</Text>
    </StyledLoader>
  );
}
